module.exports = __webpack_public_path__ + "images/hard-at-work-03b062ca3ece3bdf7bc5b29efaeaf0b4.png";